import { render } from "./Menu.vue?vue&type=template&id=5904ebfe&bindings={\"isLector\":\"options\",\"mounted\":\"options\"}"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"
script.render = render

export default script